<template>
    <div class="download">
        <h2>ACA Reference Panels</h2>
        <br>
        <div id="table">
            <table id="customers">
                <thead>
                    <tr>
                        <th style="text-transform: capitalize; cursor: pointer; font-size: 0.70rem" @click="sort(key)" v-for="(index, key) in available_datasets_list[0]" v-if="key !== 'display' && key !== 'pmid'&& key !== 'remark' && key !=='notebook' && key !=='version'">
                            <span :class="{'sort-by': true, 'active': key !== currentField, 'active-decs': 'asc' === currentSort && key === currentField, 'active-acs': 'desc' === currentSort && key === currentField }">{{ key }}</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="dataset in available_datasets_list" style="font-size: 0.70rem">
                        <td class="cell" v-for="(value, key) in dataset" v-if="key !== 'display' && key !== 'pmid'&& key !== 'remark' && key !=='notebook' && key !=='last_change'">
                            <a v-if="'dataset_name' === key" :href="uri + '/' + value + '/' + value + '.h5ad'" :title="value" target="_blank">{{ value }}</a>
                            <a v-else-if="'publication' === key" :href="pmid + dataset.pmid" :title="value" target="_blank">{{ value }}</a>
                            <div v-else-if="'visualization' === key" v-for="v in value ? value.replace(/\s/g,'').split(','): []">
                                <a :href="uri + '/' + dataset['dataset_name'] + '/' + v" target="_blank">{{ v }}</a>
                            </div>
                            <span v-else :style="{ 'font-style': 'organism' === key ? 'italic' : 'normal'}">{{ value }}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
export default {
    name: 'login',
    data: function data() {
        return {
            uri: '',
            available_datasets_list: [],
            currentField: 'dataset_name',
            currentSort: 'asc',
            pmid: 'https://www.ncbi.nlm.nih.gov/pubmed/'
        }
    },
    methods: {
        sort: function(s) {
            let _this = this
            if (s === _this.currentField) {
                _this.currentSort = _this.currentSort === 'asc' ? 'desc' : 'asc';
            }
            _this.currentField = s;
            _this.$http.post(_this.uri + '/datasets_meta', {
                field: _this.currentField,
                sortBy: _this.currentSort
            })
            .then((res) => {
                _this.available_datasets_list = res.data
            }).catch((err) => {
                console.log(err)
            })
        }
    },
    created: function beforeCreate() {
        let _this = this
        _this.$http.post(_this.uri + '/datasets_meta', {
                field: _this.currentField,
                sortBy: _this.currentSort
            })
            .then((res) => {
                _this.available_datasets_list = res.data
            }).catch((err) => {
                console.log(err)
            })
    }
}
</script>
<style scoped>
#table {
    box-shadow: 0 1px 2px rgba(0, 0, 0, .08), 0 5px 12px rgba(0, 0, 0, .04);
    font-size: 13px;
    margin: 0 5px;
    color: #555;
}

#customers {
    border-collapse: collapse;
    width: 100%;
    text-align: center;
    border-radius: 3px;
    font-weight: bold;
}

a {
    word-wrap: break-word
}

.cell {
    padding: 6px;
    border: 1px solid #555;
    overflow: hidden;
    max-width: 130px;
}

#customers tr:nth-child(even) {
    background-color: #f2f2f2;
}

#customers tr:hover {
    background-color: #ddd;
}

#customers th {
    padding-top: 6px;
    padding-bottom: 6px;
    background-color: #09B07A;
    color: white;
    border: 1px solid #555
}

th span.sort-by {
    padding-right: 20px;
    position: relative;
}

span.sort-by:before,
span.sort-by:after {
    border: 4px solid transparent;
    content: "";
    display: block;
    height: 0;
    right: 5px;
    top: 50%;
    position: absolute;
    width: 0;
}

span.active:before {
    border-bottom-color: #777;
    margin-top: -9px;
}

span.active:after {
    border-top-color: #777;
    margin-top: 1px;
}

span.active-decs:before {
    border-bottom-color: #777;
    margin-top: -9px;
}

span.active-decs:after {
    border-top-color: #fff;
    margin-top: 1px;
}

span.active-acs:before {
    border-bottom-color: #fff;
    margin-top: -9px;
}

span.active-acs:after {
    border-top-color: #777;
    margin-top: 1px;
}
</style>
